
const slider21 = document.querySelector('.banner-category-21');

let isDown21 = false;
let startX21;
let scrollLeft21;

if (slider21) {
  slider21.addEventListener("mousedown", (e) => {
    isDown21 = true;
    slider21.classList.add("active");
    startX21 = e.pageX - slider21.offsetLeft;
    scrollLeft21 = slider21.scrollLeft;
  });

  slider21.addEventListener("mouseleave", () => {
    isDown21 = false;
    slider21.classList.remove("active");
  });

  slider21.addEventListener("mouseup", () => {
    isDown21 = false;
    slider21.classList.remove("active");
  });

  slider21.addEventListener("mousemove", (e) => {
    if (!isDown21) return;
    e.preventDefault();
    const x = e.pageX - slider21.offsetLeft;
    const walk = (x - startX21) * 1;
    slider21.scrollLeft = scrollLeft21 - walk;
  });
}
//////////////////////////////
/////////////////////